/**
 * @generated SignedSource<<4c9125bc36a0f5d680867b4dd1e24f8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type login_type = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
export type LoginTypesUpdate = {
  authEnabled?: boolean | null;
  identityProviderConfigurationId?: any | null;
  loginType: login_type;
};
export type setOrgDefaultLoginTypesMutation$variables = {
  loginTypeUpdates: ReadonlyArray<LoginTypesUpdate | null>;
  organizationId: string;
};
export type setOrgDefaultLoginTypesMutation$data = {
  readonly setOrgDefaultLoginTypes: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly loginTypes: ReadonlyArray<{
      readonly authEnabled: boolean;
      readonly identityProviderConfiguration: {
        readonly id: string;
        readonly name: string;
        readonly providerType: identityprovidertype;
        readonly uuid: string;
      } | null;
      readonly loginType: login_type;
    } | null> | null;
  } | null;
};
export type setOrgDefaultLoginTypesMutation = {
  response: setOrgDefaultLoginTypesMutation$data;
  variables: setOrgDefaultLoginTypesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginTypeUpdates"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "loginTypeUpdates",
    "variableName": "loginTypeUpdates"
  },
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "IdentityProviderConfiguration",
  "kind": "LinkedField",
  "name": "identityProviderConfiguration",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "setOrgDefaultLoginTypesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetOrgDefaultLoginTypes",
        "kind": "LinkedField",
        "name": "setOrgDefaultLoginTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LoginTypes",
            "kind": "LinkedField",
            "name": "loginTypes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "setOrgDefaultLoginTypesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetOrgDefaultLoginTypes",
        "kind": "LinkedField",
        "name": "setOrgDefaultLoginTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LoginTypes",
            "kind": "LinkedField",
            "name": "loginTypes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b308ff53fbc9f475147638d154487d9a",
    "id": null,
    "metadata": {},
    "name": "setOrgDefaultLoginTypesMutation",
    "operationKind": "mutation",
    "text": "mutation setOrgDefaultLoginTypesMutation(\n  $organizationId: ID!\n  $loginTypeUpdates: [LoginTypesUpdate]!\n) {\n  setOrgDefaultLoginTypes(organizationId: $organizationId, loginTypeUpdates: $loginTypeUpdates) {\n    loginTypes {\n      loginType\n      authEnabled\n      identityProviderConfiguration {\n        id\n        uuid\n        name\n        providerType\n      }\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "6acf6da8360b04c1f420db2e3e6fc61e";

export default node;
